import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import axios from '@/axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {
            id: null,
            access_token: Cookies.get('USER_ACCESS_TOKEN'),
            mobile: null
        },
        adminNavs: []
    },
    mutations: {
        SET_USER: (state, data) => {
            state.user = data
        },
        UNSET_USER: (state) => {
            state.user = {
                id: null,
                access_token: null,
                mobile: null
            }
        }
    },
    actions: {
        setUser({commit}, data) {
            Cookies.set('USER_ACCESS_TOKEN', data.access_token, {expires: 7})
            commit('SET_USER', data)
        },
        getUser() {
            return new Promise(resolve => {
                if (this.state.user.id) {
                    return resolve(this.state.user)
                }
                axios({
                    url: 'user/info/detail'
                }).then(e => {
                    if (e.data.code === 0) {
                        return resolve(e.data.data)
                    } else {
                        return resolve(null)
                    }
                })
            })
        },
        userLogout({commit}) {
            axios({
                url: 'common/logout'
            })
            Cookies.remove('USER_ACCESS_TOKEN')
            commit('UNSET_USER')
        },
        getAdminNavs() {
            return new Promise(resolve => {
                axios({
                    url: 'admin/identity/menus'
                }).then(e => {
                    if (e.data.code === 0) {
                        resolve(e.data.data.list)
                    }
                }).catch(e => {
                })
            })
        }
    }
})
